import React, { Component } from 'react';
import { getFileName } from '../../../helpers/FileCaching';
import classes from './Header.module.scss';
import globalJson from '../../../data/global.json';
import { Link  } from "react-router-dom";

class Header extends Component {

    constructor(props) {

        super(props);
        this.navMainMarkup = this.getHeaderMarkup();
        
    }

    getHeaderMarkup(){
		
		let HeaderMarkup = [];

        for (var item in globalJson.menu.mainButtons) {

            let link = globalJson.menu.mainButtons[item];
            
            HeaderMarkup.push(

				<Link to={'index.html'} key={item} className={classes['main-header__nav-link']}>{link.title}</Link>

            )

         }
		 
		 return HeaderMarkup

    }

    render() {
        return (
            <div className={classes['main-header']}>
                <div className={classes['main-header__nav']}>
                    {this.navMainMarkup}
                </div>
            </div>
        )
    }
}

export default Header;